import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {UserLoggedIn} from "../../hooks/isUserLoggedIn";
import './LandingStyles.css';
import {useNavigate} from "react-router-dom";
import {Helmet} from 'react-helmet-async'
import ShowRoomComponent from "../ShowRoomComponent/ShowRoomComponent";

const LandingPage = () => {
    const userLoggedIn = UserLoggedIn();
    const user = useSelector(state => state.user.user) || {};
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo({top: 0, behavior: "instant"})
    },);

    return (
        <div>
            <Helmet>
                <title>The Sealab - Premium Kitchen & Closet Cabinets</title>
                <meta name="description"
                      content="Transform your home with The Sealab's premium kitchen and closet cabinets. Explore our high-quality, customizable cabinetry solutions designed to meet your unique needs."/>
                <meta name="keywords"
                      content="kitchen cabinets, closet cabinets, premium cabinets, high-quality cabinets, customizable cabinetry, home transformation, The Sealab"/>
                <meta property="og:title" content="The Sealab - Premium Kitchen & Closet Cabinets"/>
                <meta property="og:description"
                      content="Transform your home with The Sealab's premium kitchen and closet cabinets. Explore our high-quality, customizable cabinetry solutions designed to meet your unique needs."/>
                <meta property="og:url" content="https://www.thesealab.com"/>
                <meta property="og:type" content="website"/>
            </Helmet>


            {userLoggedIn ? (
                <>
                    <ShowRoomComponent/>
                </>
            ) : (
                <>
                    <ShowRoomComponent/>
                </>
            )}

        </div>

    );
};

export default LandingPage;


// import React, {useEffect, useRef, useState} from 'react';
// import {useSelector} from 'react-redux';
// import {UserLoggedIn} from "../../hooks/isUserLoggedIn";
// import {useNavigate} from "react-router-dom";
// import {Helmet} from 'react-helmet-async';
// import HeroSection from './sections/HeroSection';
// import FeaturesSection from './sections/FeaturesSection';
// import ProcessSection from './sections/ProcessSection';
// import CTASection from './sections/CTASection';
// import './LandingStyles.css';
//
// const LandingPage = () => {
//     const userLoggedIn = UserLoggedIn();
//     const user = useSelector(state => state.user.user) || {};
//     console.log('email: ', user.email)
//     const navigate = useNavigate();
//     const [isLoading, setIsLoading] = useState(true);
//     const [scrollY, setScrollY] = useState(0);
//
//     // Refs for scroll animations
//     const sectionsRef = useRef([]);
//
//     useEffect(() => {
//         // Initial scroll to top
//         window.scrollTo({top: 0, behavior: "instant"});
//
//         // Simulate loading time for entrance animation
//         const timer = setTimeout(() => {
//             setIsLoading(false);
//         }, 1000);
//
//         // Scroll event listener for animations
//         const handleScroll = () => {
//             setScrollY(window.scrollY);
//
//             // Check each section for visibility
//             sectionsRef.current.forEach(section => {
//                 if (!section) return;
//
//                 const rect = section.getBoundingClientRect();
//                 const isVisible = rect.top < window.innerHeight * 0.8 && rect.bottom > 0;
//
//                 if (isVisible) {
//                     section.classList.add('sealab-section-visible');
//                 }
//             });
//         };
//
//         window.addEventListener('scroll', handleScroll);
//
//         // Initial check
//         setTimeout(handleScroll, 100);
//
//         return () => {
//             clearTimeout(timer);
//             window.removeEventListener('scroll', handleScroll);
//         };
//     }, []);
//
//     // Function to add sections to refs
//     const addToSectionsRef = (el) => {
//         if (el && !sectionsRef.current.includes(el)) {
//             sectionsRef.current.push(el);
//         }
//     };
//
//     return (
//         <div className={`sealab-landing-container ${isLoading ? 'sealab-loading' : 'sealab-loaded'}`}>
//             <Helmet>
//                 <title>The Sealab | Revolutionary Custom Cabinetry Platform</title>
//                 <meta name="description"
//                       content="Revolutionize your custom cabinetry workflow with The Sealab's parametric design technology. Reduce design cycles from weeks to minutes and cut costs by up to 30%. Built for millworkers, architects, and contractors."/>
//                 <meta name="keywords"
//                       content="custom cabinetry, parametric design, cabinet manufacturing, millworkers, architects, contractors, cabinetry technology, distributed manufacturing"/>
//                 <meta property="og:title" content="The Sealab | Revolutionary Custom Cabinetry Platform"/>
//                 <meta property="og:description"
//                       content="Revolutionize your custom cabinetry workflow with The Sealab's parametric design technology. Reduce design cycles from weeks to minutes and cut costs by up to 30%. Built for millworkers, architects, and contractors."/>
//                 <meta property="og:url" content="https://www.thesealab.com"/>
//                 <meta property="og:type" content="website"/>
//             </Helmet>
//
//             <div className="sealab-loading-overlay" style={{opacity: isLoading ? 1 : 0}}>
//                 <div className="sealab-loading-logo">
//                     <svg viewBox="0 0 100 100" className="sealab-logo-animation">
//                         <rect x="20" y="20" width="60" height="60" className="sealab-logo-rect"/>
//                         <path d="M30 40 L70 40 L70 60 L30 60 Z" className="sealab-logo-path"/>
//                     </svg>
//                 </div>
//             </div>
//
//             <HeroSection ref={addToSectionsRef} scrollY={scrollY}/>
//
//             <div ref={addToSectionsRef} className="sealab-section">
//                 <FeaturesSection/>
//             </div>
//
//             <div ref={addToSectionsRef} className="sealab-section">
//                 <ProcessSection/>
//             </div>
//
//             {/*<div ref={addToSectionsRef} className="sealab-section">*/}
//             {/*    <TestimonialsSection/>*/}
//             {/*</div>*/}
//
//             {/*<div ref={addToSectionsRef} className="sealab-section">*/}
//             {/*    <PartnersSection/>*/}
//             {/*</div>*/}
//
//             <div ref={addToSectionsRef} className="sealab-section">
//                 <CTASection userLoggedIn={userLoggedIn}/>
//             </div>
//         </div>
//     );
// };
//
// export default LandingPage;
//
//
//
